export const PENDING = "PENDING";
export const HOLD = "HOLD";
export const OPEN = "OPEN";
export const SETTLED = "SETTLED";
export const CLOSED = "CLOSED";
export const COMPLETED = "COMPLETED";
export const AT_COUNSELLOR = "AT_COUNSELLOR";
export const AT_DOCTOR = "AT_DOCTOR";
export const AT_PHARMACY = "AT_PHARMACY";
export const CANCELLED = "CANCELLED";
export const SELECT = "SELECT";
export const TYPING = "Typing";
export const BOTH = "Both";
export const DAY_NIGHT = "Day/Night";
export const ACTIVE = "ACTIVE";
export const INACTIVE = "INACTIVE";
export const REJECTED = "REJECTED";
export const REVIEW_PENDING = "REVIEW PENDING";
export const DAMS_DEFAULT_NO = "NO";
export const DROPDOWN_TYPE = "Dropdown";
export const INPUT_TYPE = "Typing";
export const DOCTOR = "DOCTOR";

export const SERVICE_TYPE_REPORT = "SERVICE_TYPE_REPORT";
export const PATIENT_GENDER_REPORT = "PATIENT_GENDER_REPORT";
export const MEDICINE_STOCK_REPORT = "MED_STOCK_REPORT";
export const INVENTORY_REPORT = "INVENTORY_REPORT";
export const MEDICINE_BATCH_REPORT = "MED_BATCH_REPORT";
export const APPOINTMENT_SERVICE_REPORT = "APPOINTMENT_SERVICE_REPORT";
export const CANCEL_REVISIT_TRACKING = "CANCEL_REVISIT_TRACKING";
export const DIAGNOSIS_REPORT = "DIAGNOSIS_REPORT";
export const PATIENT_DETAILED_REPORT = "PATIENT_DETAILED_REPORT";
export const REVISIT_TRACKING = "REVISIT_TRACKING";
export const PAYMENT_REPORT = "PAYMENT_REPORT";
export const ACCOUNT_SERVICE_TYPE_REPORT = "ACCOUNT_SERVICE_TYPE_REPORT";
export const ORDER_SUMMARY = "ORDER_SUMMARY";
export const AVAILABLE = "AVAILABLE";
export const NOT_AVAILABLE = "NOT AVAILABLE";
export const UNDER_MAINTENANCE = "UNDER MAINTENANCE";
export const ENABLE = "ENABLE";
export const DISABLE = "DISABLED";
export const OCCUPIED = "OCCUPIED";
export const RESERVED = "RESERVED";
export const STATIC_REPORTS = {
  MONTHLY_REPORT: "MONTHLY_REPORT",
  ANNEXURE_B: "ANNEXURE_B",
  ANNEXURE_E: "ANNEXURE_E",
  ANNEXURE_F: "ANNEXURE_F",
  MONTHLY_PUNJAB_REPORT: "MONTHLY_PUNJAB_REPORT",
};
export const NO = "No";
export const YES = "Yes";
export const ADD_MORE = "ADD_MORE";
export const EXAMINATION = "examination";
export const SOAP = "soap";
export const TREATMENT = "treatment";
export const SERVICE = "service";
export const PAGES = {
  DASHBOARD: "/dashboard",
  PATIENTS: "/patients",
  PATIENT_VISIT: "/patient-visit",
  PATIENT_VISIT_V2: "/v2/patient-visit",
  PATIENT_DETAILS: "/patient-details",
  USERS: "/users",
  MEDICINES: "/medicines",
  PURCHASE_MEDICINES: "/purchase-medicines",
  SALE_RETURN: "/sale-return",
  REPORTS: "/reports",
  CHANGE_PASSWORD: "/change-password",
  HELP: "/help",
  DEPARTMENTS: "/departments",
  SUPPLIERS: "/suppliers",
  SERVICES: "/services",
  MEDS: "/meds",
  MEDICINE_TYPES: "/medicine-type",
  MEDICINE_CATEGORY: "/medicine-category",
  INVENTORY_CATEGORY: "/inventory-category",
  SERVICE_TYPES: "/service-type",
  EXPORT: "/export",
  ATTENDANCE: "/attendance",
  EXPENSE_CATEGORY: "/expense-category",
  EXPENSE: "/expense",
  ROOMS: "/rooms",
  BEDS: "/beds",
  IPD_MANAGEMENT: "/ipd-management",
  EDIT_IPD_MANAGEMENT: "/ipd-management-edit",
  ALERT: "/alert",
  CALENDAR: "/calendar",
  NEXT_VISIT: "/next-visit",
  WHATSAPP_SCHEDULE: "/whastappschedule",
  ADD_WHATSAPP_SCHEDULE: "/add-whastappschedule",
  ADD_WHATSAPP_TEMPLATE: "/add-whatsapp-template",
  TEMPLATE: "/template",
  SMS_SCHEDULE: "/smsschedule",
  ADD_SMS_SCHEDULE: "/add-smsschedule",
  ADD_SMS_TEMPLATE: "/add-sms-template",
  SMS_TEMPLATE: "/sms-template",
  PATIENT_LISTING: "/patient-list",
  DIAGNOSIS: "/diagnosis",
  APPLICATIONS: "/applications",
  BEFORE_AFTER: "/before-after",
  MEDICINE_MODAL: "/medicine-modal",
  MEDICINE_BILL: "/medicine-bill",
  CREDIT_NOTES: "/credit-notes",
  TREATMENT: "/treatment",
  TRACK_PATIENT: "/track-patient",
  ADD_PATIENT: "/add-patient",
  INVENTORY: "/inventory",
  WHATSAPPINBOX: "/whatsapp-inbox",
  DLT_CONFIG: "/dlt-config",
  DIGITAL_PRO: "/digital-pro",
  CUSTOM_BILLING_ITEMS: "/billing-items",
  DUE_TRACKER: "/due-tracker",
  PAYMENT_TRACKER: "/payment-tracker",
  EXPIRY_TRACKER: "/expiry-tracker",
  WALLET: "/wallet",
  MEDICINE_AUDIT: "/medicine-audit",
};

export const ROLES = {
  SADMIN: "SADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  HOSPITAL_ADMIN: "HOSPITAL_ADMIN",
  ADMIN: "ADMIN",
  DOCTOR: "DOCTOR",
  DOCTOR_ASSISTANT: "DOCTOR_ASSISTANT",
  PHARMACIST: "PHARMACIST",
  COUNSELLOR: "COUNSELLOR",
  RECEPTION: "RECEPTION",
  MANAGER: "MANAGER",
  STAFF: "STAFF",
  THERAPIST: "THERAPIST",
};

export const MODULES = {
  DASHBOARD_MODULE: "dashboard",
  DAMS_MODULE: "dams",
  MEDICINES_MODULE: "medicines",
  TREATMENT_MODULE: "treatment",
  SERVICIES_MODULE: "services",
  REPORTS_MODULE: "reports",
  ATTENDANCE_MODULE: "attendance",
  VIEW_PRECRIPTION: "prescription",
  VIEW_INVESTIGATION: "investigation",
  VIEW_MEDICINE_PURCHASE_RETURN: "medicine_purchase_return",
  VIEW_EXPANSE: "expense_management",
  VIEW_INVENTORY: "inventory",
  WA_INBOX: "wa_inbox",
  CANCEL_BILL_MODULE: "cancel_bill",
  VIEW_IPD: "IPD",
  VIEW_ALERT: "alerts",
  VIEW_CALANDER: "calendar",
  FINGERPRINT: "fingerprint",
  ALERT: "alerts",
  MARKETING: "marketing",
  SERVICE_ALERT: "service_alert",
  PATIENT_VISIT_ALERT: "patient_visit_alert",
  PATIENT_LISTING: "patient_listing",
  DIAGNOSIS: "diagnosis",
  TREATMENT_PLAN: "treatment_plan",
  APPLICATIONS_MODULE: "applications",
  PATIENT_FOLDER: "patient_folders",
  BEFORE_AFTER: "before_and_after",
  TREATMENT: "treatment",
  SOAP: "soap",
  PHYSICAL_EXAMINATION: "physical_examination",
  TRACK_REPORT: "track_patient",
  TELECONSULT: "teleconsult",
  CUSTOM_BILLING_ITEM: "custom_billing_item",
  VIEW_MEDICINE_SALE_RETURN: "medicine_sale_return",
  TPA_MODULE: "tpa",
  DUE_TRACKER: "view_due_tracker",
  EXPIRY_TRACKER: "view_expiry_tracker",
};
export const CUSTOM_BILLING_ITEM = MODULES.CUSTOM_BILLING_ITEM;

export const getOptionsForConfigDropdowns = {
  bill_generate: [
    {
      label: "When Order Created",
      value: "ORDER",
    },
    {
      label: "When Visit Created",
      value: "VISIT",
    },
  ],
  show_vitals: [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ],
  ui_type: [
    { label: "Old", value: "old" },
    { label: "New", value: "new" },
  ],
  show_medicine_type: [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ],
  show_dues: [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ],
  invoice_template: [
    { label: "Template 1", value: "INV_1" },
    { label: "Template 2", value: "INV_2" },
    { label: "Template 3", value: "INV_3" },
  ],
  prescription_template: [
    { label: "Template 1", value: "PRE_1" },
    { label: "Template 2", value: "PRE_2" },
    // { label: "Template 3", value: 'PRE_3' }
  ],
  patient_search_character_length: [
    { label: "3 Characters", value: "3" },
    { label: "4 Characters", value: "4" },
  ],
  prescription_type: [
    { label: "Medicine Selection", value: "Select" },
    { label: "Typing", value: "Typing" },
    { label: "Both", value: "Both" },
  ],
  prescription_dose_option_dropdown: [
    { label: "Input", value: "Typing" },
    { label: "Day/Night", value: "Day/Night" },
    { label: "Dropdown", value: "Dropdown" },
  ],
  patient_suggestion_option_dropdown: [
    { label: "Auto Select", value: "auto" },
    { label: "Show Suggestion", value: "suggestion" },
  ],
  add_services_on_visit: [
    { label: "No", value: "no" },
    { label: "Yes", value: "yes" },
  ],
  fingerprint_device: [
    { label: "MFS500", value: "MFS500" },
    { label: "MFSMock", value: "MFSMock" },
  ],
  tax_type: [
    { label: "Registered", value: "REGISTERED" },
    { label: "Composition", value: "COMPOSITION" },
    { label: "Unregistered", value: "UNREGISTERED" },
  ],
};

export const CONFIGS = {
  AADHAR_NO: "aadhar_no",
  MOBILE_NO: "mobile_no",
  ALTERNATE_MOBILE_NO: "alternate_mobile_no",
  EMAIL: "email",
  ONLINE_ID: "online_id",
  PNDT: "pndt",
  FILE_NO: "file_no",
  SPOUSE: "spouse",
  FATHER_NAME: "father_name",
  CITY: "city",
  PINCODE: "pincode",
  AREA_TYPE: "area_type",
  ADDRESS: "address",
  STATE: "state",
  DEPARTMENT: "department",
  INVESTIGATION: "investigation",
  PRESCRIPTION_FOLLOWUP: "prescription_followup",
  PRESCRIPTION_DOSE_DROPDOWN: "prescription_dose_option_dropdown",
  PRESCRIPTION: "prescription",
  PRESCRIPTION_TYPE: "prescription_type",
  MEDICINE_PURCHASE_RETURN: "medicine_purchase_return",
  AT_PHARAMACY: "input_pharmacy_name",
  NEXT_VISIT: "next_visit",
  CALENDAR_VIEW: "calendar_view",
  NEXT_VISIT_LISTING: "next_visit_listing",
  APPLICATIONS: "application",
  BILL_GENERATE: "bill_generate",
  BILL_PENDING_MEDS: "bill_pending_meds",
  SALE_RETURN_CUTOFF_DAYS: "sale_return_cutoff_days",
  SHOW_DUES: "show_dues",
  SHOW_VITALS: "show_vitals",
  SHOW_MEDICINE_TYPE: "show_medicine_type",
  TELECONSULT: "teleconsult",
  SOAP: "soap_examination",
  PHYSICAL_EXAMINATION: "physical_examination",
  UI_TYPE: "ui_type",
  DOB: "dob",
  AGE: "age",
  CUSTOM_BILLING_ITEM: "custom_billing_item",
  DATE_OF_DISCHARGE_FOR_OPD: "date_of_discharge_for_opd",
  FINGERPRINT_DEVICE: "fingerprint_device",
  MEDICINE_SALE_RETURN: "medicine_sale_return",
  TAX_TYPE: "tax_type",
  PATIENT_CATEGORY: "patient_category",
  REGISTERED: "REGISTERED",
  COMPOSITION: "COMPOSITION",
  UNREGISTERED: "UNREGISTERED",
};

export const hospitalConfigs = [
  {
    key: "aadhar_no",
    name: "Aadhar Number",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "mobile_no",
    name: "Mobile Number",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "alternate_mobile_no",
    name: "Alternate Mobile Number",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "email",
    name: "Email",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "online_id",
    name: "Online Id",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "file_no",
    name: "File Number",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "pndt",
    name: "PNDT Form Number",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "spouse",
    name: "Spouse",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "father_name",
    name: "Father/Spouse Name",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "city",
    name: "City",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "pincode",
    name: "Pincode",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "area_type",
    name: "Area Type",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "address",
    name: "Address",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "state",
    name: "State",
    show: "true",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "tax_type",
    name: "Tax Type",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "department",
    name: "Department",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "dob",
    name: "Date of Birth",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "age",
    name: "Age",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },

  {
    key: "prescription_followup",
    name: "Prescription Follow-up",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },

  {
    key: "auto_complete_print",
    name: "Auto-Completed on Print",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },

  {
    key: "calendar_view",
    name: "Calendar View",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "next_visit",
    name: "Next Visit",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "next_visit_listing",
    name: "Next Visit Listing",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "input_pharmacy_name",
    name: "At Pharmacy ",
    value: "AT_PHARMACY",
    configType: "input_pharmacy_name",
  },
  {
    key: "no_of_days",
    name: "No. of Days for Investigation",
    value: 1,
    configType: "number_input_x_days",
  },
  {
    key: "bill_generate",
    name: "Bill Number Created",
    value: getOptionsForConfigDropdowns["bill_generate"][0].value,
    configType: "dropdown",
  },
  {
    key: "bill_pending_meds",
    name: "Review pending medicine: can be bill directly or not",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "sale_return_cutoff_days",
    name: "Sale Return Lock (Days)",
    value: "90",
    configType: "text",
  },
  {
    key: "patient_search_character_length",
    name: "No. of Chars to Auto-Search Patient",
    value: getOptionsForConfigDropdowns["patient_search_character_length"][0].value,
    configType: "dropdown",
  },
  {
    key: "invoice_template",
    name: "Invoice Template",
    value: getOptionsForConfigDropdowns["invoice_template"][0].value,
    configType: "dropdown",
  },
  {
    key: "prescription_template",
    name: "Prescription Template",
    value: getOptionsForConfigDropdowns["prescription_template"][0].value,
    configType: "dropdown",
  },
  {
    key: "prescription_type",
    name: "Prescription Type",
    value: getOptionsForConfigDropdowns["prescription_type"][0].value,
    configType: "dropdown",
  },
  {
    key: "show_vitals",
    name: "Show Vitals",
    value: getOptionsForConfigDropdowns["show_vitals"][0].value,
    configType: "dropdown",
  },
  {
    key: "show_medicine_type",
    name: "Show Medicine Type",
    value: getOptionsForConfigDropdowns["show_medicine_type"][0].value,
    configType: "dropdown",
  },
  {
    key: "show_dues",
    name: "Show Dues",
    value: getOptionsForConfigDropdowns["show_dues"][0].value,
    configType: "dropdown",
  },
  {
    key: "prescription_dose_option_dropdown",
    name: "Prescription Freq/Dose Dropdown",
    value: getOptionsForConfigDropdowns["prescription_dose_option_dropdown"][0].value,
    configType: "dropdown",
  },
  {
    key: "patient_suggestion_option_dropdown",
    name: "Patient Suggestion (Single Record)",
    value: getOptionsForConfigDropdowns["patient_suggestion_option_dropdown"][0].value,
    configType: "dropdown",
  },
  {
    key: "add_services_on_visit",
    name: "Add Services on Visit",
    value: getOptionsForConfigDropdowns["add_services_on_visit"][0].value,
    configType: "dropdown",
  },
  {
    key: "px_for_prescription_header",
    name: "Space for header in prescription(px)",
    value: 0,
    configType: "px_for_prescription_header",
  },
  {
    key: "ui_type",
    name: "UI Type",
    value: getOptionsForConfigDropdowns["ui_type"][0].value,
    configType: "dropdown",
  },
  {
    key: "custom_billing_item",
    name: "Custom Billing Item",
    show: "true",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "fingerprint_device",
    name: "Fingerprint Device",
    value: getOptionsForConfigDropdowns["fingerprint_device"][0].value,
    configType: "dropdown",
  },
  {
    key: "medicine_sale_return",
    name: "Medicine Sale Return",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
  {
    key: "view_due_tracker",
    name: "Due Tracker",
    show: "false",
    mandatory: "false",
    configType: "switch",
  },
];

// Platform Administrator / Support Contact Details
export const ADMIN_SUPPORT_PHONE = "+919599110203";
export const ADMIN_SUPPORT_DISPLAY = "+91 95991 10203";
export const HOSPITAL_EXPIRY_WARNING_DAYS = 30;
